var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('NavBar',{attrs:{"title":_vm.$t('Main.article'),"routeUrl":"/"}}),_c('div',{staticClass:"article-body"},[_c('van-cell-group',_vm._l((_vm.articleData),function(item,index){return _c('van-cell',{key:index,attrs:{"title":item.title,"to":'/articleDetail?id=' + item.id,"is-link":""}})}),1),_c('Kefu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }